import React from 'react';

import styles from '../css/CoveragePPUInfoFee.module.css';

export const RowWrapper = ({ children }) => (
  <div className={styles.rowWrapper}>
    {children}
  </div>
);
